import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { setActiveTab, setStepperStep } from '../calculation.actions';
import { selectStepperStep } from '../calculation.state';
import {
  CalculationStepRoutes,
  CalculationTypeRoutes,
  getStepToCalculationStepRouteMap,
  routeToCalculationStepMap,
  routeToRoofTypeMap,
} from '../calculation.constants';
import { CoreComponent } from '../../core.component';
import { RoofProductTypeEnum } from '../../../api/models';

@Component({
  selector: 'calculation',
  templateUrl: './calculation.component.html',
  styleUrls: ['./calculation.component.scss'],
})
export class CalculationComponent extends CoreComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper') stepper!: any;

  roofTypes = CalculationTypeRoutes;
  productTypes = RoofProductTypeEnum;
  roofType?: CalculationTypeRoutes;
  step?: CalculationStepRoutes;
  title?: string;
  subtitle?: string;
  showMore = false;

  constructor(private route: ActivatedRoute, private router: Router, private store: Store<AppState>) {
    super();
  }

  ngOnInit() {
    const roofTypeRoute = this.route.snapshot.data['roofType'] as CalculationTypeRoutes;
    const roofType = routeToRoofTypeMap[roofTypeRoute];
    this.subtitle = this.route.snapshot.data['subtitle'];
    this.title = this.route.snapshot.data['title'];
    if (roofTypeRoute !== this.roofType) {
      this.store.dispatch(setActiveTab({ roofType }));
    }
    this.roofType = roofTypeRoute;
    this.garbageCollector.push(
      this.route.params.subscribe((params) => {
        let stepRoute = params['step'] as CalculationStepRoutes;
        const stepIndex = routeToCalculationStepMap[roofTypeRoute][stepRoute];

        if (!stepIndex) {
          stepRoute = CalculationStepRoutes.MODELS;
        }
        if (stepRoute !== this.step) {
          this.store.dispatch(setStepperStep({ stepperStep: routeToCalculationStepMap[roofTypeRoute][stepRoute] }));
        }

        this.step = stepRoute;
        this.updateCanonicalLink(`calcul/${roofTypeRoute}/${CalculationStepRoutes.MODELS}`);
      }),
    );
  }

  ngAfterViewInit(): void {
    this.garbageCollector.push(
      this.store.select(selectStepperStep).subscribe((stepperStep) => {
        const step = stepperStep - 1;
        this.stepper.selectedIndex = step;
        if (step !== this.stepper.selectedIndex) {
          this.router.navigate([
            'calcul',
            this.roofType,
            getStepToCalculationStepRouteMap(this.roofType || CalculationStepRoutes.MODELS)[
              this.stepper.selectedIndex + 1
            ],
          ]);
        }
      }),
    );
  }
}
